export { default } from './CatalogCardSlider';
